import { Input } from 'antd';
import classNames from 'classnames';
import { forwardRef, memo, useMemo } from 'react';
import { CustomInputProps } from '../../interfaces';
import '../../styles.scss';
import { createNewWidthHeightStyle } from '../../utils';
import './styles.scss';

const CustomInput: React.FC<CustomInputProps> = forwardRef((props, ref) => {
  const {
    value,
    height,
    onChange,
    className,
    style = {},
    upperCase = false,
    ...rest
  } = props;

  const newStyle = useMemo(() => {
    return { ...style, ...createNewWidthHeightStyle({ height }) };
  }, [height, style]);

  const newClassName = classNames(className, 'custom-input');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(
      className?.includes('controlledInput') ? (e.target.value as any) : e,
    );
  };

  return (
    <Input
      {...rest}
      ref={ref}
      style={newStyle}
      onChange={handleChange}
      className={newClassName}
      value={upperCase ? value?.toString().toUpperCase() : value}
    />
  );
});

export default memo(CustomInput);
